import request from './request'

export const get = (path, query, options = {}) => {
  return request({ path, query, method: 'GET', ...options })
}

export const post = (path, body, options = {}) => {
  return request({ path, method: 'POST', body, ...options })
}

export const put = (path, body, options = {}) => {
  return request({ path, method: 'PUT', body, ...options })
}

export const patch = (path, body, options = {}) => {
  return request({ path, method: 'PATCH', body, ...options })
}

export const del = (path, body, options = {}) => {
  return request({ path, method: 'DELETE', body, ...options })
}
